import React, { useState, useEffect } from 'react'
import { useNavigation } from '../../hooks/useWebNavigation'
// import { fetchAuthSession } from 'aws-amplify/auth'
import { getAuthToken } from '../../utils/functions.utils'

import {
    StatusBar,
    StyleSheet,
    Text,
    View,
    TouchableOpacity,
    TextInput,
    Image,
    Dimensions,
    TouchableWithoutFeedback,
    ScrollView,
    ScrollViewBase,
    FlatList,
    ActivityIndicator,
    Platform,
    useWindowDimensions,
} from 'react-native'

import { isAndroid } from '../../utils/platformUtils'

import NetInfo from '@react-native-community/netinfo'
import { AntDesign, EvilIcons, Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import { useDeviceStore } from '../../redux/zustand/deviceInfoStore'
import styles from './TriviaGameStyles'
import { TrackingServices } from '../../../database/tracking.database'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { placeholderLearning } from '../customUtils/Constants'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { BottomSheetAlert, BottomSheetBackAlert } from '../modals/BottomSheetAlert'
import { LinearGradient } from 'expo-linear-gradient'
import { StepperColors, TriviaTheme, triviaMainColorOpacity, triviaMainColor } from '../../../themeConstants'
import { searchFile } from '../customUtils/Components/ImageWIthZoom'
import { openDB } from '../../db/indexDB'
import { Loader, LoaderCustomAlert } from '../customUtils/Components/Loader'
import { INPUT_TYPE } from '../../utils/Constants'
import { request_save_game } from '../../services/trivia.services'
import { getConection } from '../appBar/context/HeaderContext'
import { ImageBackground } from 'expo-image'
import { SIDEBARFULLWIDTH } from '../customUtils/AppConstants'
import { sideBarStore } from '@/redux/zustand/sideBarStore'
const { width } = Dimensions.get('window')
const isWeb = Platform.OS === 'web'

export default function TriviaGame({ route }) {
    const { languageFile } = getLanguage()
    const { game } = route.params

    // console.log('[TriviaGame] Iniciando con route.params:', route.params)
    // console.log('[TriviaGame] Game recibido:', { name: game?.name, id: game?._id, questions: game?.questions?.length })

    const navigation = useNavigation()
    const [currentQuestion, setCurrentQuestion] = useState(0)
    const [showScore, setShowScore] = useState({ show: false, timeOut: false })
    const [isLoading, setIsLoading] = useState(false)
    const [currentEvaluation, setCurrentEvaluation] = useState(null)
    const [selectedOptions, setSelectedOptions] = useState([])

    const [labelComplet, setlabelComplet] = useState([]) // Estado para almacenar las respuestas del usuario en caso de complete_blanks
    const [positionLabel, setpositionLabel] = useState(null)

    // Obtener la evaluación al cargar el componente
    const surveyData = currentEvaluation ? currentEvaluation['questions'] : null
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [showInterModal, setShowInterModal] = useState(false)
    const path = game?._id ? `games/${game._id}` : null

    const [DATE_START, setStartDate] = useState(null)
    const { setSideBarMarginRight, sideBarMarginRight } = sideBarStore()

    useEffect(() => {
        setStartDate(new Date())
        setSideBarMarginRight(0)
        return () => {
            setSideBarMarginRight()
        }
    }, [])
    const { isConnected, hasInternet } = getConection()
    function isPair(value) {
        return value % 2 === 0
    }
    const configureGame = async () => {
        try {
            console.log('[configureGame] Iniciando configuración')
            let updatedGame = { ...game }
            // console.log('[configureGame] game.random =>', game?.random || false)
            // console.log('[configureGame] game.count =>', game?.count || 0)

            if (!game.questions || game.questions.length === 0) {
                console.warn('[configureGame] No hay preguntas disponibles')
                setCurrentEvaluation(updatedGame)
                return
            }

            let processedQuestions = [...updatedGame.questions]

            if (!game.random) {
                console.log('[configureGame] Ordenando preguntas por índice')
                processedQuestions = orderQuestionsByIndex(processedQuestions)
            }

            if (game.random) {
                console.log('[configureGame] Mezclando preguntas (random=true)')
                processedQuestions = await shuffleCuestions(processedQuestions)
            }

            const count = game.count ? Number(game.count) : 0
            if (count > 0) {
                console.log('[configureGame] Limitando a', count, 'preguntas')
                processedQuestions = processedQuestions.slice(0, count)
            } else {
                console.log('[configureGame] Mostrando todas las preguntas:', processedQuestions.length)
            }

            updatedGame.questions = processedQuestions
            console.log('[configureGame] Total de preguntas final:', updatedGame.questions.length)

            if (game.time && game.time > 0) {
                console.log('[configureGame] Configurando tiempo:', game.time)
                setTime(game.time)
            }

            console.log('[configureGame] Configuración completada')
            setCurrentEvaluation(updatedGame)
        } catch (error) {
            console.error('[configureGame] Error durante la configuración:', error)
            setCurrentEvaluation(game)
        }
    }
    const orderQuestionsByIndex = (questions) => {
        try {
            if (!questions || questions.length === 0) return questions

            const haveIndex = questions.every((q) => q.index !== undefined && q.index !== null)

            if (!haveIndex) return questions

            return questions.sort((a, b) => {
                const indexA = Number(a.index) || 0
                const indexB = Number(b.index) || 0
                return indexA - indexB
            })
        } catch (error) {
            console.error('[orderQuestionsByIndex] Error al ordenar preguntas por índice:', error)
            return questions
        }
    }
    const shuffleCuestions = async (questions) => {
        console.log('[shuffleCuestions] Iniciando shuffle con', questions.length, 'preguntas')
        let newArray = [...questions]

        for (let i = newArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1))
            ;[newArray[i], newArray[j]] = [newArray[j], newArray[i]]
        }

        newArray = newArray.map((item) => {
            let options = [...item.secondary_actions].sort(() => Math.random() - 0.5)
            return { ...item, secondary_actions: options }
        })

        console.log('[shuffleCuestions] Shuffle completado:', newArray.length, 'preguntas')
        return newArray
    }
    useEffect(() => {
        configureGame()
    }, [game])

    const [time, setTime] = useState(null)
    const timeOut = () => {
        // console.log('TimeOut')
        setShowScore({ show: true, timeOut: true })
        save_evaluation(selectedOptions, true)
    }
    const handleAnswer = async (selectedAnswer) => {
        const answer = surveyData[currentQuestion]
        const questionId = answer._id

        // Verificar el tipo de pregunta
        if (answer.input_type.type === INPUT_TYPE.SINGLE_CHOICE || answer.input_type.type === INPUT_TYPE.SINGLE_CHOICE_IMAGE) {
            // Para preguntas de opción única, deselecciona todas las opciones antes de seleccionar la nueva
            const updatedQuestions = currentEvaluation.questions.map((question, index) => {
                if (index === currentQuestion) {
                    return {
                        ...question,
                        secondary_actions: question.secondary_actions.map((option) => ({
                            ...option,
                            is_selected: option._id === selectedAnswer._id,
                        })),
                    }
                }
                return question
            })

            // Actualizar el estado de la evaluación con las preguntas actualizadas
            setCurrentEvaluation({
                ...currentEvaluation,
                questions: updatedQuestions,
            })

            // Almacenar la opción seleccionada
            setSelectedOptions((prevState) => ({
                ...prevState,
                [questionId]: [selectedAnswer],
            }))
        } else {
            if (answer.input_type.type === INPUT_TYPE.MULTIPLE_CHOICE || answer.input_type.type === INPUT_TYPE.MULTIPLE_CHOICE_IMAGE) {
                // Para preguntas de opción múltiple, permite seleccionar o deseleccionar múltiples opciones
                const updatedQuestions = currentEvaluation.questions.map((question, index) => {
                    if (index === currentQuestion) {
                        return {
                            ...question,
                            secondary_actions: question.secondary_actions.map((option) => {
                                if (option._id === selectedAnswer._id) {
                                    // Alternar la selección de la opción
                                    return {
                                        ...option,
                                        is_selected: !option.is_selected,
                                    }
                                }
                                return option
                            }),
                        }
                    }
                    return question
                })

                // Actualizar el estado de la evaluación con las preguntas actualizadas
                setCurrentEvaluation({
                    ...currentEvaluation,
                    questions: updatedQuestions,
                })

                // Obtener las opciones seleccionadas
                const selectedOptionsForQuestion = updatedQuestions[currentQuestion].secondary_actions.filter((option) => option.is_selected)

                // Almacenar las opciones seleccionadas
                setSelectedOptions((prevState) => ({
                    ...prevState,
                    [questionId]: selectedOptionsForQuestion,
                }))
            } else {
                // si entra aca es type input
                console.log('selectedAnswer', selectedAnswer)
                setSelectedOptions((prevState) => ({
                    ...prevState,
                    [questionId]: [{ input: selectedAnswer }],
                }))
            }
        }
    }
    let showCorrect = surveyData ? surveyData[currentQuestion]?.show_correct : false
    // let showCorrect = true
    const [waiting, setWaiting] = useState(false)
    const [optionsToHighlight, setOptionsToHighlight] = useState([])
    const showCorrectAnswer = () => {
        try {
            setWaiting(true)
            let answeredQuestion = Object.keys(selectedOptions).find((o) => o === surveyData[currentQuestion]._id)
            if (answeredQuestion != undefined) {
                let options = []
                for (let q of selectedOptions[answeredQuestion]) {
                    let _id = q._id
                    options.push(_id)
                }
                setOptionsToHighlight(options)
            }
            const timer = setTimeout(() => {
                highlightTimeOut()
            }, 2000)

            return () => clearTimeout(timer)
            // console.log('OPCIONES A RESALTAR ===>', selectedOptions)
        } catch (error) {
            console.error('[showCorrectAnswer] Error al resaltar respuestas correctas:', error)
        }
    }
    const highlightTimeOut = () => {
        setOptionsToHighlight([])
        setNextQuestion()
    }

    const handleNextQuestion = async () => {
        const answer = surveyData[currentQuestion]
        const questionId = answer._id
        const allQuestionsAnswered = selectedOptions[questionId]?.length > 0

        if (allQuestionsAnswered) {
            if (showCorrect) {
                showCorrectAnswer()
            } else if (answer.text_modal && answer.text_modal.length > 0) {
                setShowInterModal(true)
            } else {
                setNextQuestion()
            }

            setlabelComplet([]) // Limpiar las respuestas almacenadas para complete_blanks
            return
        } else {
            let image = require('../../../assets/evaluations/evaluationSelectOption.png')
            let title = languageFile.select_option
            let desc = languageFile.select_one_answer
            let button = languageFile.back
            openBottomSheet(<BottomSheetAlert image={image} title={title} desc={desc} button={button} closeBottomSheet={closeBottomSheet} />, ['50%'])
            //alert('Por favor, seleccione al menos una respuesta para cada pregunta.')
        }
    }
    const setNextQuestion = async () => {
        setWaiting(false)
        setShowInterModal(false)
        const answer = surveyData[currentQuestion]
        const questionId = answer._id
        const selectedAnswer = selectedOptions[questionId][0]
        const option_selected = answer['secondary_actions'].find((item) => item._id == selectedAnswer._id)
        // Verificar si la respuesta redirige a otra pregunta
        if (option_selected?.go_to) {
            if (option_selected.finish) {
                setShowScore({ show: true, timeOut: false })
                save_evaluation(selectedOptions)
            } else {
                const nextQuestionIndex = Number(option_selected.go_to) - 1 // El índice de la próxima pregunta
                setCurrentQuestion(nextQuestionIndex) // Actualizar el estado de la pregunta actual
            }
        } else {
            if (currentQuestion + 1 >= surveyData.length) {
                setShowScore({ show: true, timeOut: false })
                save_evaluation(selectedOptions)
            } else {
                setCurrentQuestion(currentQuestion + 1)
            }
        }
    }

    const save_evaluation = async (answer, timeOut = false) => {
        setIsLoading(true)

        // console.log("TR:" , JSON.stringify(answer))
        try {
            if (isConnected && hasInternet) {
                let parsedAnswers = await parseAnswersToSend(answer, timeOut)

                let body = {
                    answers: parsedAnswers,
                    date_start: DATE_START,
                    date_finish: new Date(),
                }
                const authToken = await getAuthToken()
                let game_id = currentEvaluation._id
                const data = await request_save_game({ authToken, game_id, body })
            }
        } catch (error) {
            console.log('🚀 ~ file: survey.js ~ line 78 ~ isApprovedEvaluation ~ error', error)
            setIsLoading(false)
        } finally {
            setIsLoading(false)
        }
    }

    const ShowBottons = () => {
        let modalTitle = showScore.timeOut ? 'Se agotó el tiempo' : 'Has terminado la triviallll'
        let modalDescription = showScore.timeOut ? 'El tiempo de la trivia se ha agotado' : 'Has terminado la trivia'
        //showScore.timeOut
        if (showScore.timeOut) {
            if (!isWeb) {
                return (
                    <LinearGradient style={styles.container} colors={TriviaTheme.timeOutGradient} start={{ x: 0.5, y: 1 }} end={{ x: 0.5, y: 0 }}>
                        <View style={[styles.feedbackContainer]}>
                            <View style={styles.feedbackInfoContainer}>
                                <Image source={require('../../../assets/trivia/triviaIncompleta.png')} style={styles.modalImageRespuesta} />
                                <Text style={styles.feedbackTitle}>{languageFile.game_unfinished_title1}</Text>
                                <Text style={styles.feedbackDescription4}>{languageFile.game_unfinished_title2}</Text>

                                <TouchableOpacity
                                    // onPress={() => navigation.reset({ index: 0, routes: [{ name: 'LearningHome' }] })}
                                    onPress={() => navigation.goBack()}
                                    style={styles.buttonContainer}
                                >
                                    <Text style={styles.closeTextTransparent}>{languageFile.close}</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </LinearGradient>
                )
            } else {
                return (
                    <LinearGradient
                        style={[{ width: '100%', height: '100%', flex: 1 }]}
                        colors={TriviaTheme.timeOutGradient}
                        start={{ x: 0.5, y: 1 }}
                        end={{ x: 0.5, y: 0 }}
                    >
                        <Image
                            source={require('../../../assets/trivia/triviaCompleteDecoration.png')}
                            style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, opacity: 0.32 }}
                        />
                        <View style={[styles.feedbackContainer]}>
                            <View style={[styles.feedbackInfoContainer, { maxWidth: 524 }]}>
                                <Image source={require('../../../assets/trivia/triviaTimeOutWeb.png')} style={styles.modalImageRespuesta} />
                                <Text
                                    style={{
                                        fontSize: 22,
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        color: theme.colors.darkGray,
                                        marginBottom: 8,
                                        alignSelf: 'center',
                                    }}
                                >
                                    {languageFile.game_unfinished_title1}
                                </Text>
                                <Text
                                    style={{
                                        fontSize: 14,
                                        textAlign: 'center',
                                        color: theme.colors.darkGray,
                                        paddingHorizontal: 20,
                                        marginBottom: 30,
                                        alignSelf: 'center',
                                    }}
                                >
                                    {languageFile.game_unfinished_title2}
                                </Text>

                                <TouchableOpacity onPress={() => navigation.goBack()} style={styles.buttonContainer}>
                                    <Text
                                        style={[
                                            {
                                                fontSize: 12,
                                                fontWeight: 'bold',
                                                borderRadius: 15,
                                                color: theme.colors.darkGray,
                                                borderColor: theme.colors.darkGray,
                                                borderWidth: 1,
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                width: 232,
                                                paddingVertical: 10,
                                            },
                                        ]}
                                    >
                                        {languageFile.close}
                                    </Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </LinearGradient>
                )
            }
        } else {
            if (!isWeb) {
                return (
                    <LinearGradient style={styles.container} colors={TriviaTheme.finishedGradient} start={{ x: 0.5, y: 1 }} end={{ x: 0.5, y: 0 }}>
                        <View style={[styles.feedbackContainer]}>
                            {/* <StatusBar backgroundColor={theme.colors.triviaFinishGradientStart} barStyle='light-content' /> */}
                            <View style={styles.feedbackInfoContainer}>
                                <Image source={require('../../../assets/trivia/triviaCompleta.png')} style={styles.modalImageRespuesta} />
                                <Text style={styles.feedbackTitle}>{languageFile.game_completed_title1}</Text>
                                <Text style={styles.feedbackDescription2}>{languageFile.game_completed_title2}</Text>
                                <Text style={styles.feedbackDescription3}>{languageFile.game_completed_title3}</Text>
                                <Text style={styles.feedbackDescription4}>{languageFile.game_completed_title4}</Text>
                                <TouchableOpacity
                                    // onPress={() => navigation.reset({ index: 0, routes: [{ name: 'LearningHome' }] })}
                                    onPress={() => navigation.goBack()}
                                    style={styles.buttonContainer}
                                >
                                    <Text style={styles.closeTextTransparent}>{languageFile.close}</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </LinearGradient>
                )
            } else {
                return (
                    <LinearGradient
                        style={[{ width: '100%', height: '100%', flex: 1 }]}
                        colors={TriviaTheme.finishedGradient}
                        start={{ x: 0.5, y: 1 }}
                        end={{ x: 0.5, y: 0 }}
                    >
                        <Image
                            source={require('../../../assets/trivia/triviaCompleteDecoration.png')}
                            style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, opacity: 0.32 }}
                        />
                        <View style={[styles.feedbackContainer, { maxWidth: 524 }]}>
                            <View style={styles.feedbackInfoContainer}>
                                <Image source={require('../../../assets/trivia/triviaCompleteWeb.png')} style={styles.modalImageRespuesta} />
                                <Text
                                    style={{
                                        fontSize: 22,
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        color: triviaMainColor,
                                        marginBottom: 2,
                                        alignSelf: 'center',
                                    }}
                                >
                                    {languageFile.game_completed_title1}
                                </Text>
                                <Text
                                    style={{
                                        fontSize: 18,
                                        textAlign: 'center',
                                        color: triviaMainColor,
                                        paddingHorizontal: 20,
                                        marginBottom: 12,
                                        alignSelf: 'center',
                                    }}
                                >
                                    {languageFile.game_completed_title2}
                                </Text>
                                <Text
                                    style={{
                                        fontSize: 14,
                                        textAlign: 'center',
                                        color: triviaMainColor,
                                        paddingHorizontal: 20,
                                        marginBottom: -2,
                                        alignSelf: 'center',
                                    }}
                                >
                                    {languageFile.game_completed_title3}
                                </Text>
                                <Text
                                    style={{
                                        fontSize: 14,
                                        textAlign: 'center',
                                        color: triviaMainColor,
                                        paddingHorizontal: 20,
                                        marginBottom: 30,
                                        alignSelf: 'center',
                                    }}
                                >
                                    {languageFile.game_completed_title4}
                                </Text>
                                <TouchableOpacity onPress={() => navigation.goBack()} style={styles.buttonContainer}>
                                    <Text style={[styles.closeTextTransparent, { width: 232, backgroundColor: 'white', color: triviaMainColor }]}>
                                        {languageFile.close}
                                    </Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </LinearGradient>
                )
            }
        }
    }

    const complete_blanks = (index, value) => {
        let update_option = false
        // console.log('🟢 estoy en complete_blank index:', index, 'value:', value, 'positionLabel', positionLabel, 'labelComplet:', labelComplet)
        const question = currentEvaluation.questions[currentQuestion]
        const text = question.title
        const modifiedText = text.replace(/_+/g, 'none')
        let blanks_original = modifiedText.split(' ')

        if (labelComplet.length > 0) {
            blanks_original = labelComplet
        }

        if (index !== null) {
            if (value !== '') {
                blanks_original[index] = value
            } else {
                //aca es cuando borra o selecciona donde quire  completar
                //primero deselecciono el que estaba seleccionado
                let prev_option = blanks_original[index]
                if (prev_option) {
                    console.log('🚀 ~ Survey ~ prev_option:', prev_option)
                    let find_question = question.secondary_actions.find((option) => option.label == prev_option)
                    if (find_question) {
                        // console.log('🚀 ~ =========>>> ~ find_question:', find_question)
                        selectOption(find_question._id, false)
                    }
                }
                //limpio el campo
                setpositionLabel(index)
                blanks_original[index] = 'none'
            }
        } else {
            // aca me llega el value pero no el index
            //aca no llega la posicion
            if (positionLabel !== null) {
                if (blanks_original[positionLabel]) {
                    blanks_original[positionLabel] = value.label
                    setpositionLabel(null)
                    update_option = true
                }
            } else {
                const find_index = blanks_original.indexOf('none')
                if (find_index !== -1) {
                    blanks_original[find_index] = value.label
                    update_option = true
                }
            }
        }

        // Actualiza el estado selectedOptions si es necesario
        if (update_option) {
            const selectedOptionId = value?._id
            selectOption(selectedOptionId, true)
        }

        setlabelComplet([...blanks_original])
        setSelectedOptions((prevState) => ({
            ...prevState,
            // [question._id]: [...blanks_original],
            // [question._id]: [value]
            [question._id]: blanks_original.map((word, idx) =>
                word === 'none' ? 'none' : question.secondary_actions.find((opt) => opt.label === word) || word,
            ),
        }))
    }

    const selectOption = (optionId, is_selected) => {
        const question = currentEvaluation.questions[currentQuestion]

        // Actualiza el estado is_selected de la opción seleccionada
        const updatedSecondaryActions = question.secondary_actions.map((option) => {
            if (option._id === optionId) {
                return {
                    ...option,
                    is_selected: is_selected,
                }
            }
            return option
        })

        // Actualiza el estado de la evaluación con la pregunta actualizada
        setCurrentEvaluation({
            ...currentEvaluation,
            questions: currentEvaluation.questions.map((q, index) => {
                // Solo actualiza la pregunta actual
                if (index === currentQuestion) {
                    return {
                        ...question,
                        secondary_actions: updatedSecondaryActions,
                    }
                }
                return q
            }),
        })
    }

    const validateCorrectAnswers = () => {
        if (!currentEvaluation) return false
        const question = currentEvaluation.questions[currentQuestion]

        let all_correct = true
        switch (question.input_type.type) {
            case INPUT_TYPE.COMPLETE_BLANKS:
                const labelCompString = labelComplet.join(' ').toLocaleLowerCase() || ''
                const correctWords = question.text_correct.toLocaleLowerCase() // Respuesta correcta

                if (labelCompString != correctWords) {
                    all_correct = false
                }
                break
            case INPUT_TYPE.SINGLE_CHOICE:
            case INPUT_TYPE.SINGLE_CHOICE_IMAGE:
            case INPUT_TYPE.MULTIPLE_CHOICE:
            case INPUT_TYPE.MULTIPLE_CHOICE_IMAGE:
                question.secondary_actions.forEach((action) => {
                    if (action.correct && !action.is_selected) {
                        all_correct = false
                    }
                    if (action.is_selected && !action.correct) {
                        all_correct = false
                    }
                })
                break
            default:
                console.log('Unknown question type')
                break
        }
        return all_correct
    }
    let allCorrect = validateCorrectAnswers()
    let modal_text = surveyData ? surveyData[currentQuestion].text_modal : ''

    const parseAnswersToSend = async (answers, timeOut) => {
        // console.log('answers', answers)
        let answersToSend = []
        Object.keys(answers).forEach((questionId) => {
            // console.log('QuesitonID', questionId)
            const question = currentEvaluation.questions.find((question) => question._id === questionId)
            let score = answers[questionId].reduce((sum, q) => sum + q.score, 0)
            let status = question.score == score ? 1 : -1
            let a = {
                question_id: questionId,
                questionText: question.title,
                score: status == 1 ? score : 0,
                status: status,
            }
            let optionSelectedId = []
            let optionSelectedText = []

            if (question.input_type.type === INPUT_TYPE.COMPLETE_BLANKS) {
                let selectedLabels = answers[questionId]
                const matchedOptions = selectedLabels
                    .map((label) => {
                        return question.secondary_actions.find((option) => option.label === label)
                    })
                    .filter((option) => option !== undefined)
                optionSelectedId.push(...matchedOptions.map((option) => option._id))
                optionSelectedText.push(...matchedOptions.map((option) => option.label))
                // console.log('answers[questionId]', answers[questionId])
            } else {
                //Este else contempla single y multiple_choice con y sin imagen. Cambiar por switch si se agregan types
                optionSelectedId = answers[questionId].map((option) => option._id)
                optionSelectedText = answers[questionId].map((option) => option.label)
            }
            a.optionSelectedId = optionSelectedId
            a.optionSelectedText = optionSelectedText
            answersToSend.push(a)
        })
        if (timeOut) {
            currentEvaluation.questions.forEach((question) => {
                if (!answers[question._id.toString()]) {
                    let a = {
                        question_id: question._id.toString(),
                        questionText: question.title,
                        score: 0,
                        status: -1,
                        optionSelectedId: [],
                        optionSelectedText: [],
                    }
                    answersToSend.push(a)
                }
            })
        }

        // console.log("answersToSend => " , JSON.stringify(answersToSend))

        return answersToSend
    }

    const renderQuestionContent = () => {
        switch (currentEvaluation.questions[currentQuestion]?.input_type.type) {
            case INPUT_TYPE.MULTIPLE_CHOICE_IMAGE:
            case INPUT_TYPE.SINGLE_CHOICE_IMAGE:
                let content = currentEvaluation.questions[currentQuestion]?.secondary_actions || []
                let isContentPair = isPair(content.length)
                if (!isContentPair) {
                    let ghostItem = { _id: 'ghost' }
                    content.push(ghostItem)
                }
                return (
                    <View style={[styles.optionsContainer, isWeb && { maxWidth: 350, justifyContent: 'center', alignSelf: 'center' }]}>
                        <View style={[styles.imageContainer]}>
                            {content
                                .sort((a, b) => (a._id === 'ghost' ? 1 : b._id === 'ghost' ? -1 : 0))
                                .map((item) => {
                                    if (item._id === 'ghost') {
                                        return <View key={item._id} style={[styles.optionImage, { opacity: 0 }, isWeb && { width: 152 }]} />
                                    }
                                    let highlight = optionsToHighlight.includes(item._id)
                                    let correctNotSelected = optionsToHighlight.length > 0 && !optionsToHighlight.includes(item._id) && item.correct
                                    return (
                                        <TouchableOpacity key={item._id} onPress={() => handleAnswer(item)}>
                                            <RenderImage item={item} path={path} highLight={highlight} correctNotSelected={correctNotSelected} />
                                        </TouchableOpacity>
                                    )
                                })}
                        </View>
                    </View>
                )
            case INPUT_TYPE.COMPLETE_BLANKS:
                const question = currentEvaluation.questions[currentQuestion]
                const text = question['title']
                const modifiedText = text.replace(/_+/g, 'none')
                const blanks = modifiedText.split(' ')
                // const options = currentEvaluation.questions[currentQuestion].secondary_actions.map((option) => option)
                const blankContainerStyle = !isWeb ? styles.optionContainer : styles.optionContainerWeb
                const blankContainerSelectedStyle = !isWeb ? styles.selectedOption : styles.selectedOptionWeb
                const blankOptionStyle = !isWeb ? styles.options : styles.optionsWeb
                const blankOptionSelectedStyle = !isWeb ? styles.selectedOptionText : styles.selectedOptionTextWeb
                return (
                    <View style={styles.optionsContainer}>
                        <View style={styles.optionsSubContainer}>
                            {blanks.map((part, index) => {
                                return (
                                    <View key={index} style={styles.flexDirectionRow}>
                                        {part === 'none' ? (
                                            <TouchableOpacity
                                                onPress={() => complete_blanks(index, '')}
                                                style={
                                                    labelComplet[index]
                                                        ? labelComplet[index] != 'none'
                                                            ? styles.complete
                                                            : styles.chip
                                                        : styles.chip
                                                }
                                            >
                                                <Text style={styles.chipText}>
                                                    {labelComplet[index] ? (labelComplet[index] != 'none' ? labelComplet[index] : '') : ''}
                                                </Text>
                                            </TouchableOpacity>
                                        ) : (
                                            <Text style={styles.optionText}>{part} </Text>
                                        )}
                                    </View>
                                )
                            })}
                        </View>

                        {/*<Text style={styles.optionTextDetails}>{currentEvaluation.questions[currentQuestion]?.input_type[0].title}</Text>*/}

                        <View style={styles.completeBlanksContainer}>
                            {currentEvaluation?.questions[currentQuestion]?.secondary_actions.map((option, optionIndex) => (
                                <TouchableOpacity
                                    key={optionIndex}
                                    onPress={() => complete_blanks(null, option)}
                                    style={[blankContainerStyle, option?.is_selected && blankContainerSelectedStyle]}
                                    disabled={option?.is_selected}
                                >
                                    <Text style={[blankOptionStyle, option?.is_selected && blankOptionSelectedStyle]}>{option.label}</Text>
                                </TouchableOpacity>
                            ))}
                        </View>
                    </View>
                )

            default:
                // Renderizar las opciones para preguntas de opción única o múltiple

                const options = currentEvaluation.questions[currentQuestion]?.secondary_actions.map((item) => {
                    let highlight = optionsToHighlight.includes(item._id)
                    let correctNotSelected = optionsToHighlight.length > 0 && !optionsToHighlight.includes(item._id) && item.correct

                    let highLightContainerStyle = item.correct ? styles.highLightOptionCorrectContainer : styles.highLightOptionIncorrectContainer
                    let highLightContainerStyleWeb = item.correct
                        ? styles.highLightOptionCorrectContainerWeb
                        : styles.highLightOptionIncorrectContainerWeb

                    let highLightTextStyle = item.correct ? styles.highLightOptionCorrectText : styles.highLightOptionIncorrectText
                    let highLightTextStyleWeb = item.correct ? styles.highLightOptionCorrectTextWeb : styles.highLightOptionIncorrectTextWeb

                    const containerStyles = [
                        styles.optionContainer,
                        item.is_selected && styles.selectedOption,
                        correctNotSelected && styles.correctNotSelectedContainer,
                        highlight && highLightContainerStyle,
                    ]
                    const containerStylesWeb = [
                        styles.optionContainerWeb,
                        item.is_selected && styles.selectedOptionWeb,
                        correctNotSelected && styles.correctNotSelectedContainerWeb,
                        highlight && highLightContainerStyleWeb,
                    ]

                    const itemStyles = [
                        styles.options,
                        item.is_selected && styles.selectedOptionText,
                        correctNotSelected && styles.correctNotSelectedText,
                        highlight && highLightTextStyle,
                    ]
                    const itemStylesWeb = [
                        styles.optionsWeb,
                        item.is_selected && styles.selectedOptionTextWeb,
                        correctNotSelected && styles.correctNotSelectedTextWeb,
                        highlight && highLightTextStyleWeb,
                    ]

                    //Estilos para el item
                    let container = isWeb ? containerStylesWeb : containerStyles
                    let finalItem = isWeb ? itemStylesWeb : itemStyles

                    return (
                        <TouchableOpacity onPress={() => handleAnswer(item)} style={container} key={item.label}>
                            <Text style={finalItem}>{item.label}</Text>
                        </TouchableOpacity>
                    )
                })

                return <View style={styles.optionsContainer}>{options}</View>
        }
    }

    if (!isWeb) {
        return (
            <View style={styles.container}>
                {isLoading ? (
                    <LoaderCustomAlert />
                ) : (
                    <>
                        {currentEvaluation && currentEvaluation.questions ? (
                            showScore.show ? (
                                <ShowBottons />
                            ) : (
                                <LinearGradient
                                    style={{
                                        paddingTop: isAndroid() ? 12 : 45,
                                        width: width,
                                        flex: 1,
                                        pointerEvents: waiting ? 'none' : null,
                                    }}
                                    colors={[theme.colors.linearGradientEnd, theme.colors.linearGradientStart]}
                                    start={{ x: 0, y: 1 }}
                                    end={{ x: 0, y: 0 }}
                                >
                                    {/* <TouchableOpacity style={styles.backIcon} onPress={() => showBackModal()}>
                                    <Feather name='arrow-left' size={20} color={colorIcon} />
                                </TouchableOpacity> */}
                                    <LineStepper currentQuestion={currentQuestion} totalQuestions={currentEvaluation.questions.length} />

                                    <Text style={styles.titleEvaluationText}>{currentEvaluation.name ?? ''}</Text>
                                    <Text style={styles.optionTextDetails}>
                                        {languageFile.Questions + ' '}
                                        {currentQuestion + 1}
                                        {languageFile.of}
                                        {currentEvaluation.questions.length}
                                    </Text>
                                    {time && time > 0 && <CustomTimerView time={time} timeOut={() => timeOut()} waiting={waiting} />}

                                    <ScrollView showsVerticalScrollIndicator={false}>
                                        <View style={styles.parent}>
                                            <View style={styles.questionContainer}>
                                                {currentEvaluation.questions[currentQuestion]?.input_type.type !== INPUT_TYPE.COMPLETE_BLANKS && (
                                                    <View>
                                                        <Text style={styles.optionText}>{currentEvaluation.questions[currentQuestion]?.title}</Text>
                                                        {currentEvaluation.questions[currentQuestion]?.media &&
                                                            currentEvaluation.questions[currentQuestion]?.media != '' && (
                                                                <View style={styles.container_image}>
                                                                    <Image
                                                                        source={{ uri: currentEvaluation.questions[currentQuestion]?.media }}
                                                                        style={styles.optionImage}
                                                                    />
                                                                </View>
                                                            )}
                                                    </View>
                                                )}
                                                {renderQuestionContent()}
                                                <View style={styles.buttonContainer}>
                                                    <TouchableOpacity
                                                        onPress={() => handleNextQuestion()}
                                                        style={[
                                                            styles.borderButton,
                                                            { backgroundColor: TriviaTheme.triviaGameNextButtonBackgroundColor },
                                                        ]}
                                                    >
                                                        <Text style={[styles.borderButtonText]}>{languageFile.confirm}</Text>
                                                    </TouchableOpacity>
                                                </View>
                                            </View>
                                        </View>
                                    </ScrollView>
                                </LinearGradient>
                            )
                        ) : (
                            <Text style={[{ marginTop: 100 }, styles.optionText]}>{languageFile.loading_evaluation}</Text>
                        )}

                        {showInterModal && (
                            <InterModal name={currentEvaluation.name ?? ''} correct={allCorrect} text={modal_text} next={() => setNextQuestion()} />
                        )}
                    </>
                )}
            </View>
        )
    } else {
        return (
            <View
                style={{
                    width: '100%',
                    height: '100%',
                    alignItems: 'center',
                    alignContent: 'center',
                }}
            >
                {isLoading ? (
                    <LoaderCustomAlert />
                ) : (
                    <>
                        {currentEvaluation && currentEvaluation.questions ? (
                            showScore.show ? (
                                <ShowBottons />
                            ) : (
                                <LinearGradient
                                    style={{
                                        width: '100%',
                                        flex: 1,
                                        pointerEvents: waiting ? 'none' : null,
                                        alignItems: 'center',
                                    }}
                                    colors={[triviaMainColorOpacity, 'white']}
                                    start={{ x: 0.5, y: 1 }}
                                    end={{ x: 0.5, y: 0 }}
                                    {...(isWeb && { pointerEvents: waiting ? 'none' : null })} // Se agreá para web ya que no respeta el del style como mobile
                                >
                                    <View style={{ flex: 1, maxWidth: 680, paddingTop: 45, width: '100%' }}>
                                        <LineStepper
                                            currentQuestion={currentQuestion}
                                            totalQuestions={currentEvaluation.questions.length}
                                            stepHeight={2}
                                        />

                                        <Text style={[styles.titleEvaluationText, { color: theme.colors.textSecondary, alignSelf: 'center' }]}>
                                            {currentEvaluation.name ?? ''}
                                        </Text>
                                        <Text
                                            style={[
                                                styles.optionTextDetails,
                                                { color: theme.colors.textSecondary, alignSelf: 'center', marginBottom: 10 },
                                            ]}
                                        >
                                            {languageFile.Questions + ' '}
                                            {currentQuestion + 1}
                                            {languageFile.of}
                                            {currentEvaluation.questions.length}
                                        </Text>
                                        {time && time > 0 && (
                                            <CustomTimerView time={time} timeOut={() => timeOut()} waiting={waiting} maxWidth={'40%'} />
                                        )}

                                        <ScrollView showsVerticalScrollIndicator={false}>
                                            <View style={styles.parent}>
                                                <View style={[styles.questionContainer, { marginTop: 5 }]}>
                                                    {currentEvaluation.questions[currentQuestion]?.input_type.type !== INPUT_TYPE.COMPLETE_BLANKS && (
                                                        <View>
                                                            <Text style={[styles.optionText, { color: triviaMainColor }]}>
                                                                {currentEvaluation.questions[currentQuestion]?.title}
                                                            </Text>
                                                            {currentEvaluation.questions[currentQuestion]?.media &&
                                                                currentEvaluation.questions[currentQuestion]?.media != '' && (
                                                                    <View style={styles.container_image}>
                                                                        <Image
                                                                            source={{ uri: currentEvaluation.questions[currentQuestion]?.media }}
                                                                            style={{
                                                                                width: '35%',
                                                                                aspectRatio: 1 / 1,
                                                                                borderRadius: 10,
                                                                                margin: 10,
                                                                            }}
                                                                        />
                                                                    </View>
                                                                )}
                                                        </View>
                                                    )}
                                                    {renderQuestionContent()}
                                                    <View style={styles.buttonContainer}>
                                                        <TouchableOpacity
                                                            onPress={() => handleNextQuestion()}
                                                            style={[
                                                                styles.borderButton,
                                                                { backgroundColor: 'white', paddingHorizontal: 70 },
                                                                waiting && { backgroundColor: theme.colors.lightGray },
                                                            ]}
                                                            disabled={waiting}
                                                        >
                                                            <Text
                                                                style={[
                                                                    styles.borderButtonText,
                                                                    { color: triviaMainColor },
                                                                    waiting && { color: theme.colors.darkGray },
                                                                ]}
                                                            >
                                                                {languageFile.confirm}
                                                            </Text>
                                                        </TouchableOpacity>
                                                    </View>
                                                </View>
                                            </View>
                                        </ScrollView>
                                    </View>
                                </LinearGradient>
                            )
                        ) : (
                            <Text style={[{ marginTop: 100 }, styles.optionText]}>{languageFile.loading_evaluation}</Text>
                        )}

                        {showInterModal && (
                            <InterModal name={currentEvaluation.name ?? ''} correct={allCorrect} text={modal_text} next={() => setNextQuestion()} />
                        )}
                    </>
                )}
            </View>
        )
    }
}

const RenderImage = ({ item, path, highLight, correctNotSelected }) => {
    const [newMedia, setNewMedia] = useState(item.media)
    let highLightContainerStyle = item.correct ? styles.highLightOptionCorrectContainer : styles.highLightOptionIncorrectContainer
    let highLightContainerStyleWeb = item.correct ? styles.highLightOptionCorrectContainerWeb : styles.highLightOptionIncorrectContainerWeb
    const highLightContainer = isWeb ? highLightContainerStyleWeb : highLightContainerStyle
    const imageStyles = [
        styles.optionImage,
        item.is_selected && styles.selectedOptionImage,
        correctNotSelected && [styles.correctNotSelectedContainer, { borderWidth: 4 }],
        highLight && highLightContainer,
    ]
    const imageStylesWeb = [
        styles.optionImage,
        item.is_selected && styles.selectedOptionImageWeb,
        correctNotSelected && [styles.correctNotSelectedContainerWeb, { borderWidth: 4 }],
        highLight && highLightContainer,
        { width: 152 },
    ]
    const finalImageStyles = isWeb ? imageStylesWeb : imageStyles
    const imageOverlay = () => {
        const selectedIcon = require('../../../assets/gamification/gamif_selected.png')
        const checkIcon = require('../../../assets/gamification/gamif_check.png')
        const wrongIcon = require('../../../assets/gamification/gamif_wrong.png')
        let overlay = null
        if (item.is_selected) {
            overlay = { icon: selectedIcon, color: TriviaTheme.imageSelectedIconColor }
        }
        if (correctNotSelected) {
            overlay = { icon: checkIcon, color: TriviaTheme.imageCorrectNotSelectedIconColor }
        }
        if (highLight) {
            if (item.correct) {
                overlay = { icon: checkIcon, color: TriviaTheme.imageCorrectIconColor }
            } else {
                overlay = { icon: wrongIcon, color: TriviaTheme.imageIncorrectIconColor }
            }
        }
        if (overlay === null) return null
        return (
            <View
                style={{
                    flex: 1,
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Image source={overlay.icon} style={{ width: 60, height: 60, tintColor: overlay.color }} />
            </View>
        )
    }
    useEffect(() => {
        const fetchMedia = async () => {
            const mediaLocal = path ? await searchFile(item.media, path) : item.media
            setNewMedia(mediaLocal)
        }
        fetchMedia()
    }, [item.media, path])
    return (
        <ImageBackground source={{ uri: newMedia ? newMedia : placeholderLearning }} style={[finalImageStyles]}>
            {imageOverlay()}
        </ImageBackground>
    )
}

const InterModal = ({ name, correct, text, next }) => {
    if (!isWeb) {
        return (
            <View
                style={{
                    position: 'absolute',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    width: '100%',
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                }}
            >
                <View style={styles.modalBox}>
                    <Image
                        style={styles.IntermodalImage}
                        source={correct ? require('../../../assets/trivia/CheckmarkTrivia.png') : require('../../../assets/trivia/errorTrivia.png')}
                        resizeMode='contain'
                        resizeMethod='resize'
                    />
                    <Text style={styles.modalText}>{text}</Text>
                    {/* <Text style={styles.modalText2}>{correct ? 'Correcto' : 'Incorrecto'}</Text> */}
                    <Text style={styles.modalText2}>
                        {correct
                            ? '¡Bien hecho! 🎉 Sumaste puntos y vas por el camino correcto. Seguí así y demostrá todo tu conocimiento.'
                            : '¡Ups! 😕 No era la respuesta correcta, pero no te rindas. Aprendé de esta y preparate para la próxima pregunta. ¡Vos podés! 🚀'}
                    </Text>
                    <Text style={styles.modalText3}>{name}</Text>
                    <TouchableOpacity onPress={() => next()}>
                        <Text style={styles.mainButton}>Siguiente</Text>
                    </TouchableOpacity>
                </View>
            </View>
        )
    } else {
        return (
            <View
                style={{
                    position: 'absolute',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    width: '100%',
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                }}
            >
                <LinearGradient
                    style={{
                        width: '100%',
                        backgroundColor: 'white',
                        borderRadius: 10,
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignContent: 'center',
                        padding: 35,
                        maxWidth: 540,
                        marginHorizontal: 16,
                    }}
                    colors={[triviaMainColorOpacity, 'white']}
                    start={{ x: 0.5, y: 1 }}
                    end={{ x: 0.5, y: 0 }}
                >
                    <Image
                        style={styles.IntermodalImage}
                        source={correct ? require('../../../assets/trivia/triviaWebRight.png') : require('../../../assets/trivia/triviaWebWrong.png')}
                        resizeMode='contain'
                        resizeMethod='resize'
                    />
                    <Text style={[styles.modalText, { color: triviaMainColor, marginTop: 24, marginBottom: 12 }]}>{text}</Text>
                    {/* <Text style={styles.modalText2}>{correct ? 'Correcto' : 'Incorrecto'}</Text> */}
                    <Text style={[styles.modalText2, { marginBottom: 0 }]}>
                        {correct
                            ? '¡Bien hecho! 🎉 Sumaste puntos y vas por el camino correcto. Seguí así y demostrá todo tu conocimiento.'
                            : '¡Ups! 😕 No era la respuesta correcta, pero no te rindas. Aprendé de esta y preparate para la próxima pregunta. ¡Vos podés! 🚀'}
                    </Text>
                    <Text style={[styles.modalText3, { marginVertical: 24 }]}>{name}</Text>
                    <TouchableOpacity onPress={() => next()}>
                        <Text style={[styles.mainButton, { backgroundColor: 'white', color: triviaMainColor }]}>Siguiente</Text>
                    </TouchableOpacity>
                </LinearGradient>
            </View>
        )
    }
}
export const CustomTimerView = ({ time, timeOut, waiting, maxWidth = null }) => {
    const [remainingTime, setRemainingTime] = useState(time)

    useEffect(() => {
        if (waiting) return
        if (remainingTime > 0) {
            const timer = setTimeout(() => setRemainingTime(remainingTime - 1), 1000)
            return () => clearTimeout(timer)
        } else {
            timeOut()
        }
        console.log('TimeOut')
    }, [remainingTime, waiting])

    const widthPercentage = (remainingTime / time) * 100
    const styles = StyleSheet.create({
        timerContainer: {
            flex: 1,
            backgroundColor: 'transparent',
            height: 10,
            justifyContent: 'center',
            marginHorizontal: 15,
            borderRadius: 20,
            overflow: 'hidden',
            borderColor: TriviaTheme.triviaTimerBorderColor,
            borderWidth: 1,
            maxWidth: maxWidth ? maxWidth : undefined,
        },
        timerBar: {
            flex: 1,
            height: 10,
            backgroundColor: TriviaTheme.triviaTimerColor,
        },
    })
    return (
        <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: 15 }}>
            {!isWeb ? (
                <Image
                    style={{ width: 20, marginStart: 15 }}
                    source={require('../../../assets/triviaTimer.png')}
                    resizeMode='contain'
                    tintColor={TriviaTheme.triviaTimerAssetColor}
                />
            ) : (
                <Image style={{ width: 30, height: 30 }} source={require('../../../assets/trivia/triviaTimerWeb.png')} resizeMode='contain' />
            )}

            <View style={styles.timerContainer}>
                <View style={[styles.timerBar, { width: `${widthPercentage}%` }]} />
            </View>
        </View>
    )
}

const LineStepper = ({ currentQuestion, totalQuestions, stepHeight = 4 }) => {
    return (
        <View style={{ flexDirection: 'row', marginHorizontal: 15, marginVertical: 20 }}>
            {[...Array(totalQuestions)].map((_, index) => (
                <View
                    key={index}
                    style={{
                        flex: 1,
                        height: stepHeight,
                        backgroundColor:
                            currentQuestion > index
                                ? StepperColors.previousStepColor
                                : currentQuestion === index
                                ? StepperColors.currentStepColor
                                : StepperColors.nextStepColor,
                        marginHorizontal: 5,
                    }}
                />
            ))}
        </View>
    )
}
